// extracted by mini-css-extract-plugin
export default {"banner":"offline-banner_banner__1g8+J","dot":"offline-banner_dot__v0YZF","pulse":"offline-banner_pulse__2oG4R"};